import { Locale } from 'global/interfaces';
import { LocaleType } from 'global/types';
import locales from '.';

const getCurrentLocale = (locale: LocaleType): Locale => {
  return locales.find(l => l.locale === locale)!;
};

export default getCurrentLocale;
